/* ─────────────────────────────────────────────────────────────────
   AXIS — X Series · Shared theme JS
   No dependencies. Provides:
   - .axis-reveal IntersectionObserver attach
   - window.AxisScroll.progress(el) helper for sticky hero
   ───────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  /* ── Reveal-on-scroll ──────────────────────────────────────── */
  function attachReveals(root) {
    var nodes = (root || document).querySelectorAll('.axis-reveal:not([data-axis-revealed])');
    if (!nodes.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          e.target.setAttribute('data-axis-revealed', '1');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -10% 0px' });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ── Scroll progress utility for sticky elements ───────────── */
  function getProgress(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight;
    var total = r.height - vh;
    if (total <= 0) return 0;
    var passed = Math.max(0, Math.min(total, -r.top));
    return passed / total;
  }

  /* ── Re-attach reveals when Shopify customiser re-renders ──── */
  document.addEventListener('DOMContentLoaded', function () { attachReveals(); });
  document.addEventListener('shopify:section:load', function (e) { attachReveals(e.target); });
  document.addEventListener('shopify:section:reorder', function () { attachReveals(); });

  /* Expose for sections that need scroll progress */
  window.AxisScroll = {
    progress: getProgress,
    attachReveals: attachReveals
  };
})();
